// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Greenland from '../_raw/flag/icon_flag_greenland.png';

export default () => <img src={Greenland} alt="Greenland" />;
